import styled from "@emotion/styled"

const LogoWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: center;
`
export default LogoWrapper
